import { Component } from '@angular/core';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { BlFrontendButtonComponent } from 'src/app/core/wrappers/bl-frontend-button.component';

@Component({
  selector: 'app-firm-task-template-ask-archive',
  template: `
    <div>
      <p>
        Den kommer då inte bli valbar som ny tjänst på dina klienter. Tidigare upplagda fortsätter att fungera.
        <br />Vill du fortsätta?
      </p>
      <div class="flex w-full pt-6 justify-end">
        <bl-frontend-button variant="secondary" (onclick)="archiveTaskTemplate(false)" text="Nej"></bl-frontend-button>
        <bl-frontend-button class="ml-2" (onclick)="archiveTaskTemplate(true)" text="Ja"></bl-frontend-button>
      </div>
    </div>
  `,
  standalone: true,
  imports: [BlFrontendButtonComponent],
})
export class FirmTaskTemplateAskArchiveDialog {
  // eslint-disable-next-line no-useless-constructor
  constructor(private ref: DynamicDialogRef) {}

  archiveTaskTemplate = (ok: boolean) => {
    this.ref.close(ok);
  };
}
